import { apolloClient } from '@/apollo/client'
import { MAINTENANCE_NOTIFICATIONS_QUERY } from '@/graphql/maintenanceNotification/maintenanceNotifications'

export const MaintenanceNotificationService = {
    all () {
        return apolloClient.query({
            query: MAINTENANCE_NOTIFICATIONS_QUERY,
        }).then(response => response.data.maintenanceNotifications)
    },
}
